import React from "react";
import styles from "./styles.module.scss";
import cn from "classnames";
import useWindowWidth from "hooks/useWindowWidth";

const SupportStats = ({ stats }) => {
  const width = useWindowWidth();

  return (
    <div className={styles.wrapper}>
      <div className="title_lg block_center font_extra-bold">
        Support that really cares
      </div>
      <div className={styles.stats_container}>
        {stats.map((stat, index) => {
          return (
            <>
              <div key={stat.title} className={styles.stat_container}>
                <h3 className={cn("title_md-lg font_bold")}>{stat.title}</h3>
                <div className="text_md">{stat.description}</div>
              </div>
              {index + 1 !== stats.length && width > 1250 && (
                <div className={styles.dot} />
              )}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default SupportStats;
